import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import axios from "axios"

const { Option } = Select 

/**
 * @const SelectCuentas
 * @description Select para las cuentas registrados en el sistema
 */
const SelectCuentas = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Select account", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null,
        labelInValue
    } = props

    const [ cuentas, setCuentas ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getCuentas
     * @description Obitiene las cuentas
     */
    const getCuentas = ({
        page, 
        limit, 
        search, 
    } = cuentas) => {

        axios.get('/cuentas', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setCuentas(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error getting accounts')
        })
    }

    //componentDidMount
    useEffect(() => {
        getCuentas()
    }, [])


    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getCuentas({search})}
            onSelect={(cuenta)=> {
                if(mode === null && !labelInValue){
                    onChange(cuenta.value)
                    onSelect(cuenta.value)
                }
                if(mode === null && labelInValue){
                    onChange(cuenta)
                    onSelect(cuenta)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple" && !labelInValue){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }

                if(mode === "multiple" && labelInValue){
                    onChange(values)
                    onSelect(values)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                cuentas?.data?.map(({ _id, nombre}) => <Option value={_id} key={_id}>{nombre ?? ""}</Option>)
            }
        </Select>
    );
}



export default SelectCuentas;